<template>
  <v-app>
    <TheHeader />

    <TheNavigation />

    <TheBreadcrumbs />

    <v-main>
      <ErrorDialog ref="errorDialog" />
      <ConfirmationDialog ref="confirmationDialog" />
      <router-view />
    </v-main>

    <TheFooter />
  </v-app>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import TheNavigation from '@/components/TheNavigation.vue';
import TheBreadcrumbs from '@/components/TheBreadcrumbs.vue';
import TheFooter from '@/components/TheFooter.vue';
import ErrorDialog from '@/components/dialogs/ErrorDialog.vue';
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog.vue';

export default {
  name: 'App',
  components: {
    TheHeader,
    TheNavigation,
    TheBreadcrumbs,
    TheFooter,
    ErrorDialog,
    ConfirmationDialog,
  },
  data() {
    return {
      showError: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.showError = false;
      }
    },
  },
  created() {
    this.$eventBus.$on('error400', (error) => {
      this.$root.$errorDialog.open('', error);
    });
    this.$eventBus.$on('error500', (error) => {
      if (error.cause === 'MAINTENANCE') {
        this.$router.push({
          name: '503-maintenance',
        });
      } else {
        this.$root.$errorDialog.open('SYSTÉM JE DOČASNĚ NEDOSTUPNÝ', error);
      }
    });
    this.$eventBus.$on('errorNetwork', (error) => {
      this.$root.$errorDialog.open('SYSTÉM JE DOČASNĚ NEDOSTUPNÝ', error);
    });
    this.$eventBus.$on('fileNotFound', (error) => {
      this.$root.$errorDialog.open('SOUBOR NEBYL NALEZEN', error);
    });
  },
  mounted() {
    this.$root.$errorDialog = this.$refs.errorDialog;
    this.$root.$confirmationDialog = this.$refs.confirmationDialog;
  },
};
</script>
